import React from "react";

const Adds = () => {
  return (
    <React.Fragment>
      <div className="col-sm-3">
        <h2>Ads</h2>
        Icons made by{" "}
        <a
          href="https://www.flaticon.com/authors/pixel-perfect"
          title="Pixel perfect"
        >
          Pixel perfect
        </a>{" "}
        from{" "}
        <a href="https://www.flaticon.com/" title="Flaticon">
          {" "}
          www.flaticon.com
        </a>
        <br />
        Icons made by{" "}
        <a href="https://www.flaticon.com/authors/freepik" title="Freepik">
          Freepik
        </a>{" "}
        from{" "}
        <a href="https://www.flaticon.com/" title="Flaticon">
          {" "}
          www.flaticon.com
        </a>
        <br />
        <a href="https://thenounproject.com/search/?q=home&i=1076883">
          House by Тимур Минвалеев from the Noun Project
        </a>
        <a href="https://thenounproject.com/search/?q=profile&i=956157">
          profile by icongeek from the Noun Project
        </a>
        <a href="https://thenounproject.com/search/?q=notes&i=3107500">
          note by IcoMoon from the Noun Project
        </a>
        <a href="https://thenounproject.com/search/?q=settings&i=2650511">
          Settings by i cons from the Noun Project
        </a>
      </div>
    </React.Fragment>
  );
};

export default Adds;
